export default __webpack_public_path__ + "static/logo-djangocms-10a5baaeb7b24d1b939f0eac04bb6583.png";